/***
 * 运力资源
 *  */
// 定制逻辑处理
export default {
  // 运力资源-承运单位-承运公司运价信息支持3位小数
  carrier_price_precision: ['96179', '82635'] // 202510161109417507773
}
